/* eslint-disable prefer-promise-reject-errors */
import { request } from './request'
import store from '../store/index'
import * as qiniu from 'qiniu-js'
const UPLOAD_ERROR_CODE = 1002
const baseUrl = process.env.VUE_APP_BASEURL_USER
// 数据字典接口
export const dictionaryData = (code, update) => {
  if (
    store.state.dictionaries &&
    store.state.dictionaries[code] &&
    store.state.dictionaries[code].data.code === 0 &&
    !update
  ) {
    return new Promise((resolve, reject) => {
      resolve(store.state.dictionaries[code])
    })
  } else {
    return request({
      method: 'get',
      // url: 'http://yapi.batmobi.cn/mock/364/api/v1/common/dics/{code}'
      url: `/api/v1/common/dics/${code}`
    })
  }
}
export const loginByWechat = code =>
  request({
    method: 'get',
    url: `/api/v1/admin/login/qywechat/${code}`
  })

// 数据字典 列表接口-code接口
export const getDicByCode = code =>
  request({
    method: 'get',
    url: `/ocean/api/v1/shop/merchant/dict/${code}`
  })
// 商家词典-列表接口 更新接口
export const postUpdateDicByCode = (data) => {
  const url = '/ocean/api/v1/shop/merchant/dict/sequence'
  return request({
    method: 'post',
    url: url,
    data
  })
}
// 商家树状词典-列表接口 售后原因
export const putMerchantConfig = (type, data) => {
  let url = `/ocean/api/v1/shop/merchant/dict/tree/${type}`
  if (data && data.name) {
    url += '?name=' + data.name
  }

  return request({
    method: 'get',
    url: url,
    data
  })
}
// 商家树状词典-添加或编辑
export const putMerchantConfigUpdate = (data) => {
  const url = '/ocean/api/v1/shop/merchant/dict/tree/saveOrUpdate'
  return request({
    method: 'put',
    url: url,
    data
  })
}
// 商家树状词典-删除
export const delMerchantConfigUpdate = (id) => {
  const url = `/ocean/api/v1/shop/merchant/dict/tree/delete?id=${id}`
  return request({
    method: 'get',
    url: url,
  })
}
// 获取权限目录
export const getAuthorityMenu = (id) => {
  return request({
    method: 'get',
    url: `${baseUrl}/api/v1/user/permission/actions/ocean/${id}`
  })
}

// 获取基础配置信息
export const getMerchantConfig = params => {
  const url = '/api/v1/merchant/config'
  return request({
    method: 'get',
    url: url,
    params
  })
}
// 退出登录
export const logout = () => {
  return request({
    method: 'get',
    url: `${baseUrl}/api/v1/user/logout/ocean`
  })
}
// 基础配置信息-保存
export const putMerchantConfigSave = data => {
  const url = '/api/v1/merchant/config'
  return request({
    method: 'put',
    url: url,
    data
  })
}
// 商家账户列表 - 负责人列表
export const leaderList = data => {
  const url = '/ocean/api/v1/shop/user/list'
  return request({
    method: 'get',
    url: url,
    ...data
  })
}
// 商品系列组件接口
export const collectionsComponent = data => {
  const url = '/api/v1/collections/component'
  return request({
    method: 'get',
    url: url,
    ...data
  })
}
// 活动页面组件接口
export const promotionsComponent = data => {
  const url = '/api/v1/marketing/component'
  return request({
    method: 'get',
    url: url,
    ...data
  })
}
// 根据title模糊查询商品
export const collectionsProducts = data => {
  const url = '/api/v1/products'
  return request({
    method: 'get',
    url: url,
    ...data
  })
}
// 根据title模糊查询文章
export const getAticale = data => {
  const url = '/api/v1/articles/component'
  return request({
    method: 'get',
    url: url,
    ...data
  })
}
// 历史图片列表接口
export const getHistoryImages = params => {
  const url = '/api/v1/templates/historyImages'
  return request({
    method: 'get',
    url: url,
    params
  })
}

// 插入历史图片接口
export const inserHistoryImages = data => {
  const url = '/api/v1/templates/insertHistoryImage'
  return request({
    method: 'post',
    url: url,
    data
  })
}

export const getUploadConfig = (type, fileName) => {
  const url = '/ocean/api/v1/common/file/upload/token'
  return request({
    method: 'get',
    url: url,
    params: { type, fileName }
  })
}
// 文件上传
export const uploadFile = (file, type) => {
  const postData = new FormData()
  postData.append('type', type || 'collection')
  postData.append('file', file)
  const url = '/ocean/api/v1/common/file/upload'
  return request({
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: url,
    data: postData
  })
}

// 文件直接上传七牛云
export const uploadFileDirect = async (file, type = 'collection', nextFn) => {
  const fileName = file.name
  const res = await getUploadConfig(type, file.name)
  const { data } = res
  if (data.code === window.eventBus.$code) {
    const { path, token, region = qiniu.region.z2, qiniuDomain } = data.data
    const putExtra = {
      fname: fileName
    }
    const config = {
      useCdnDomain: true,
      region: region
    }
    return new Promise((resolve, reject) => {
      const observable = qiniu.upload(file, path, token, putExtra, config)
      const subscription = observable.subscribe({
        error(err) {
          reject({
            data: {
              code: UPLOAD_ERROR_CODE,
              msg: err.message
            }
          })
        },
        complete(respon) {
          setTimeout(() => {
            resolve({
              data: {
                code: 0,
                data: {
                  absolutePath: qiniuDomain + path,
                  relativePath: path
                }
              }
            })
          }, 200)
        },
        next(respon) {
          nextFn && nextFn(respon)
        }
      })
    })
  } else {
    return res
  }
}

// 获取数据及广告(之前没填过的话无数据)
export const getMerchantData = data => {
  const url = '/api/v1/merchant/ad_data'
  return request({
    method: 'get',
    url: url,
    ...data
  })
}
// 更新数据及广告
export const putMerchantData = data => {
  const url = '/api/v1/merchant/ad_data'
  return request({
    method: 'put',
    url: url,
    data
  })
}

// 站点管理-店铺列表
export const getMerchantList = data => {
  const url = '/api/v1/merchant/config/list'
  return request({
    method: 'get',
    url: url,
    ...data
  })
}
// 站群管理-新增站点-即新增站点配置
export const postMerchantConfig = data => {
  const url = '/api/v1/merchant/config'
  return request({
    method: 'post',
    url: url,
    data
  })
}
// 复制站点
export const copyShop = data => {
  const url = '/api/v1/shop/copy'
  return request({
    method: 'post',
    url: url,
    data
  })
}
// 复制站点
export const queryCopyShopStatus = taskId => {
  const url = `/api/v1/shop/copy/${taskId}/progress`
  return request({
    method: 'get',
    url: url
  })
}

// 全站通用消息通知接口, http://yapi.batmobi.cn/project/364/interface/api/18872
export const queryNotifications = () => {
  return request({
    method: 'get',
    url: '/api/v1/notifications'
  })
}

// 完成站点通知接口, http://yapi.batmobi.cn/project/364/interface/api/18879
export const finishNotifications = notificationId => {
  const url = `/api/v1/notifications/${notificationId}`
  return request({
    method: 'get',
    url
  })
}
export const allCountries = () => {
  const url = '/api/v1/common/countrys/name'
  return request({
    method: 'get',
    url
  })
}

// 营销活动，设置默认折扣, http://yapi.batmobi.cn/project/364/interface/api/19201
export const setDefaultDiscount = data => {
  return request({
    method: 'post',
    url: '/api/v1/marketing/setDefaultDiscount',
    data
  })
}

// 营销活动，获取默认折扣
export const getDefaultDiscount = params => {
  return request({
    method: 'get',
    url: '/api/v1/marketing/getDefaultDiscount',
    params
  })
}

export const addImportTask = data => {
  const url = '/api/v1/import/task/add'
  return request({
    method: 'post',
    url,
    data
  })
}

export const checkImportStatus = taskId => {
  const url = `/api/v1/import/task/${taskId}`
  return request({
    method: 'get',
    url
  })
}
export const getInnerToken = params => {
  return request({
    method: 'get',
    url: '/api/v1/shoplus/user/inner_token/get',
    params
  })
}

export const moveShopSort = params => {
  return request({
    method: 'get',
    url: '/api/v1/merchant/move/top_bottom',
    params
  })
}

export const getLanguage = data => {
  return request({
    method: 'post',
    url: `${process.env.VUE_APP_BURIER}/api/v1/admin/back_i18n/vocabulary/listVocabulary`,
    data
  })
}
export const updateLanguageCDNPost = data => {
  return request({
    method: 'post',
    url: `${process.env.VUE_APP_BURIER}/api/v1/admin/back_i18n/file`,
    data
  })
}
export const getLanguageCDN = params => {
  return request({
    method: 'get',
    url: `${process.env.VUE_APP_BURIER}/api/v1/admin/back_i18n/file/${params.systemId}/${params.language}`,
  })
}
export const updateLanguageCDN = url => {
  return request({
    method: 'get',
    url,
    fileJSON: true,
    withCredentials: false,
    headers: {},
  })
}
// 表头配置
export const getColumnConfig = type => {
  return request({
    method: 'get',
    url: `/ocean/api/v1/shop/header-config`,
    params: type
  })
}
export const saveColumnConfig = data => {
  return request({
    method: 'post',
    url: `/ocean/api/v1/shop/header-config`,
    data
  })
}


// 初始化邮件标签、售后原因数据
export const initDataTagReason = data => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/shop/merchant/dict/tree/initDictTree',
    params: data
  })
}

// 初始化邮件分类、顾客标签、顾客等级数据
export const initDataDict = data => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/shop/merchant/dict/tree/initDict',
    params: data
  })
}
